<div class="outer-container">
    <div *ngFor="let msg of infoMessages">
        <div class="header-info">
            <div><mat-icon class="icon">info</mat-icon></div>
            <ng-container>
                <span [innerHTML]="msg" class="paragraph-medium-regular"></span>
            </ng-container>
        </div>
    </div>
    <div *ngFor="let msg of warningMessages">
        <div class="header-warning">
            <div><mat-icon class="icon">warning</mat-icon></div>
            <ng-container>
                <span [innerHTML]="msg" class="paragraph-medium-regular"></span>
            </ng-container>
        </div>
    </div>
    <div *ngFor="let msg of errorMessages">
        <div class="header-error">
            <div><mat-icon class="icon">error</mat-icon></div>
            <ng-container>
                <span [innerHTML]="msg" class="paragraph-medium-regular"></span>
            </ng-container>
        </div>
    </div>
</div>